import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Accordion, Form } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './ProjectDataTable.css';
import moment from 'moment';

interface Project {
    [key: string]: any;
}

interface Props {
    projects: Project[];
    progress: boolean;
    filtersActive: boolean;
    activeTableFilters: any;
    onFilterSubmit: (filterData: { keyName: string; dateFrom: string; dateTo: string; field: string }) => void;
    onSingleProjectSelect: (pin: number) => void;
    onRemoveFilter: (table: string) => void;
}

const ProjectDataTable: React.FC<Props> = ({ projects, progress, filtersActive, activeTableFilters, onFilterSubmit, onSingleProjectSelect, onRemoveFilter }) => {

    const [accordionStates, setAccordionStates] = useState<{ [key: string]: boolean }>({});
    const [tableDateStates, setTableDateStates] = useState<{ [key: string]: { dateFrom: string; dateTo: string } }>({});

    const [nrr, setNrr] = useState<Project[]>([]);
    const [cdr, setCdr] = useState<Project[]>([]);
    const [cds, setCds] = useState<Project[]>([]);
    const [ldv, setLdv] = useState<Project[]>([]);

    const tables = [
        { title: 'NRR', data: nrr, dateField: 'nrr', keyName: 'sD_NRROk', baselineKey: 'sD_NRROkB', statusKey: 'sD_NRROkS' },
        { title: 'CDR', data: cdr, dateField: 'cdr', keyName: 'sD_CDROk', baselineKey: 'sD_CDROkB', statusKey: 'sD_CDROkS' },
        { title: 'CDS', data: cds, dateField: 'cds', keyName: 'sD_CDSLay', baselineKey: 'sD_CDSLayB', statusKey: 'sD_CDSLayS' },
        { title: 'LDV', data: ldv, dateField: 'ldv', keyName: 'sD_LDVOk', baselineKey: 'sD_LDVOkB', statusKey: 'sD_LDVOkS' },
    ];

    const [bodyText, setBodyText] = useState<string>(
        'Use the search form to show records here'
    );

    const createProjectsStructure = async () => {
        const BRAND_SUB_KEY = "sBrandSub";

        const NRR_KEY = "sD_NRROk";
        const NRR_BASELINE_KEY = "sD_NRROkB";
        const NRR_STATUS_KEY = "sD_NRROkS";

        const CDR_KEY = "sD_CDROk";
        const CDR_BASELINE_KEY = "sD_CDROkB";
        const CDR_STATUS_KEY = "sD_CDROkS";

        const CDS_KEY = "sD_CDSLay";
        const CDS_BASELINE_KEY = "sD_CDSLayB";
        const CDS_STATUS_KEY = "sD_CDSLayS";

        const LDV_KEY = "sD_LDVOk";
        const LDV_BASELINE_KEY = "sD_LDVOkB";
        const LDV_STATUS_KEY = "sD_LDVOkS";

        const nrr_projects: any[] = [];
        const cdr_projects: any[] = [];
        const cds_projects: any[] = [];
        const ldv_projects: any[] = [];

        projects.forEach((project: any) => {
            const projectData = {
                pin: project.projectId,
                subBrand: project[BRAND_SUB_KEY]
            };

            if (project[NRR_KEY]) {
                nrr_projects.push({ ...projectData, nrr: project[NRR_KEY], baseline: project[NRR_BASELINE_KEY], status: project[NRR_STATUS_KEY] });
            }
            if (project[CDR_KEY]) {
                cdr_projects.push({ ...projectData, cdr: project[CDR_KEY], baseline: project[CDR_BASELINE_KEY], status: project[CDR_STATUS_KEY] });
            }
            if (project[CDS_KEY]) {
                cds_projects.push({ ...projectData, cds: project[CDS_KEY], baseline: project[CDS_BASELINE_KEY], status: project[CDS_STATUS_KEY] });
            }
            if (project[LDV_KEY]) {
                ldv_projects.push({ ...projectData, ldv: project[LDV_KEY], baseline: project[LDV_BASELINE_KEY], status: project[LDV_STATUS_KEY] });
            }
        });



        setNrr(nrr_projects);
        setCdr(cdr_projects);
        setCds(cds_projects);
        setLdv(ldv_projects);
    };

    const handleTebleFilterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        if (!(formData.get("tableFilterDateFrom") as string) && !(formData.get("tableFilterDateTo") as string)) {
            return;
        }

        const data = {
            keyName: formData.get("keyName") as string,
            dateFrom: formData.get("tableFilterDateFrom") as string,
            dateTo: formData.get("tableFilterDateTo") as string,
            field: formData.get("field") as string,
        };

        closeAccordion(data.field);
        onFilterSubmit(data)
    };

    const toggleAccordion = (key: string) => {
        setAccordionStates((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const closeAccordion = (key: string) => {
        setAccordionStates((prevState) => ({
            ...prevState,
            [key]: false,
        }));
    };

    useEffect(() => {
        createProjectsStructure();
    }, [projects]);

    useEffect(() => {
        setBodyText(
            progress
                ? 'Loading...'
                : 'Use the search form to show records here'
        );
    }, [progress]);

    return (

        <Row className="justify-content-center">
            {tables.map((table, index) => (
                <Col md={6} key={index}>
                    <Card className={`data-card mb-4${filtersActive ? ' filter-active' : ''}${activeTableFilters[table.title] ? ' spec-filter-active' : ''}`} style={{ overflow: 'hidden' }}>

                        <Card.Body className="p-0">
                            <div className="table-field-name">{table.title}</div>
                            {projects.length > 0 ?
                                (
                                    <>
                                        <div className="table-filter-container">

                                            <Accordion
                                                className={`p-1${activeTableFilters[table.title] ? ' acc-filter-active' : ''}`}
                                                activeKey={accordionStates[table.title] ? "0" : null}
                                            >
                                                <Accordion.Item className="p-0 table-filter-accordion" eventKey="0">
                                                    <Accordion.Header
                                                        onClick={() => toggleAccordion(table.title)}
                                                    >
                                                        <div className="table-filter-title">
                                                            {activeTableFilters[table.title] ? (
                                                                <span className="active-filter-acc-btn">
                                                                    Projects filtered by {table.title} date range
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    Filter Projects by {table.title} date range
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <form
                                                            className="filter-form-container"
                                                            onSubmit={(e) => {
                                                                e.preventDefault();
                                                                handleTebleFilterSubmit(e);

                                                            }}
                                                        >
                                                            <div className="filter-form">
                                                                <div className="col-12 col-md-6 mb-3">
                                                                    <Form.Group className="filter-form-group">
                                                                        <Form.Label
                                                                            htmlFor={`${table.dateField}DateFrom`}
                                                                            className="filter-form-label"
                                                                        >
                                                                            Date from
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            name="tableFilterDateFrom"
                                                                            className="rounded-pill"
                                                                            id={`${table.dateField}DateFrom`}
                                                                            type="date"
                                                                            value={tableDateStates[table.title]?.dateFrom || ""}
                                                                            onFocus={(e: any) => e.currentTarget.showPicker()}
                                                                            onChange={(e) => {
                                                                                const dateFrom = e.target.value;
                                                                                setTableDateStates((prevState) => ({
                                                                                    ...prevState,
                                                                                    [table.title]: {
                                                                                        ...prevState[table.title],
                                                                                        dateFrom,
                                                                                        dateTo: prevState[table.title]?.dateTo || "",
                                                                                    },
                                                                                }));
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                </div>
                                                                <div className="col-12 col-md-6 mb-3">
                                                                    <Form.Group className="filter-form-group">
                                                                        <Form.Label
                                                                            htmlFor={`${table.dateField}DateTo`}
                                                                            className="filter-form-label"
                                                                        >
                                                                            Date to
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            name="tableFilterDateTo"
                                                                            className="rounded-pill"
                                                                            id={`${table.dateField}DateTo`}
                                                                            type="date"
                                                                            value={tableDateStates[table.title]?.dateTo || ""}
                                                                            min={tableDateStates[table.title]?.dateFrom || ""}
                                                                            disabled={!tableDateStates[table.title]?.dateFrom}
                                                                            onFocus={(e: any) => e.currentTarget.showPicker()}
                                                                            onChange={(e) => {
                                                                                const dateTo = e.target.value;
                                                                                setTableDateStates((prevState) => ({
                                                                                    ...prevState,
                                                                                    [table.title]: {
                                                                                        ...prevState[table.title],
                                                                                        dateTo,
                                                                                    },
                                                                                }));
                                                                            }}
                                                                        />
                                                                    </Form.Group>
                                                                </div>


                                                                <input type="hidden" name="keyName" value={table.keyName} />
                                                                <input type="hidden" name="field" value={table.title} />
                                                            </div>
                                                            {activeTableFilters[table.title] ? (
                                                                <>
                                                                    <div className="d-flex justify-content-center mt-4">
                                                                        <button
                                                                            className="btn btn-sm btn-primary mx-1"
                                                                            type="submit"
                                                                            disabled={!tableDateStates[table.title]?.dateTo}
                                                                        >
                                                                            Update filter
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-sm btn-danger mx-1"
                                                                            type="button"
                                                                            onClick={() => onRemoveFilter(table.title)}
                                                                        >
                                                                            Remove filter
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="d-flex justify-content-center mt-4">
                                                                    <button
                                                                        className="btn btn-sm btn-primary mx-1"
                                                                        type="submit"
                                                                        disabled={!tableDateStates[table.title]?.dateTo}
                                                                    >
                                                                        Apply filter
                                                                    </button>
                                                                </div>
                                                            )}

                                                        </form>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </div>
                                        <div className="table-container" style={{ height: "380px", overflowY: "auto" }}>
                                            <Table striped className="m-0">
                                                <thead>
                                                    <tr>
                                                        <th className="small text-center">
                                                            PIN#
                                                        </th>
                                                        <th className="small text-center">
                                                            Sub Brand
                                                        </th>
                                                        <th colSpan={2} className="small text-center">
                                                            Due Date
                                                        </th>

                                                        <th className="small text-center">
                                                            VS Today
                                                        </th>
                                                        <th className="small text-center">
                                                            VS Baseline
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="small px-0">
                                                    {table.data.map((data, rowIndex) => {
                                                        const date = moment(data[table.dateField]);
                                                        const baselineDate = moment(data.baseline);

                                                        const diffDays = date.diff(moment(), "days");
                                                        const baselineDiffDays = baselineDate.diff(date, "days")

                                                        const diffColor = diffDays < 0 ? "#EE312F" : "#6BA772";
                                                        const baselineDiffColor = baselineDiffDays < 0 ? "#EE312F" : "#6BA772";

                                                        return (
                                                            <tr key={rowIndex}>
                                                                <th className="small text-center">
                                                                    <span className="project-pin" onClick={() => onSingleProjectSelect(data.pin)}>{data.pin}</span>
                                                                </th>
                                                                <td className="small text-center">
                                                                    {data.subBrand}
                                                                </td>
                                                                <td className="small text-center">
                                                                    <div>{date.format("ll")}</div>
                                                                </td>
                                                                <td className="small text-center">
                                                                    <div><b>{data.status}</b></div>
                                                                </td>
                                                                <td className="small text-center">
                                                                    <div style={{ color: diffColor }}>{`${diffDays} d`}</div>
                                                                </td>
                                                                <td className="small text-center">
                                                                    {data.baseline ? (
                                                                        <OverlayTrigger overlay={
                                                                            <Tooltip>
                                                                                <small>
                                                                                    Baseline: <b>{baselineDate.format("ll")}</b>
                                                                                </small>
                                                                            </Tooltip>
                                                                        }>
                                                                            <div style={{ color: baselineDiffColor }}>{`${baselineDiffDays} d`}</div>
                                                                        </OverlayTrigger>
                                                                    ) : (
                                                                        <div>-</div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </>
                                ) : (
                                    <div className="no-results-table-ph">
                                        No projects matching with current search or filters criteria
                                    </div>
                                )}

                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row >
    );
};

export default ProjectDataTable;